export enum HealthLevel {
  Green = 'Green',
  Yellow = 'Yellow',
  Red = 'Red',
  Gray = 'Gray',
  Blue = 'Blue'
}
